import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

// styles
import colors from '../../styles/colors'

function HeaderTab({
  headerItem, // 탭 아이템 []
  headerLinks, // 탭 link []
  selectedItem, // 선택된 아이템
  handleItem, // 핸들러
  isDesktop, // 데스크탑부터 표시
  maxWidth, // 최대 width
}) {
  return (
    <Container isDesktop={isDesktop} maxWidth={maxWidth}>
      <SelectWrapper>
        <OutsideSelect />
        {headerItem.map((item, idx) => (
          <React.Fragment key={idx}>
            {headerLinks && headerLinks[idx] ? (
              <Link to={`${headerLinks[idx]}`} key={idx}>
                <ItemSelect isActive={idx === selectedItem}>{item}</ItemSelect>
                <ItemSelectGap />
              </Link>
            ) : (
              <>
                <ItemSelect
                  isActive={idx === selectedItem}
                  onClick={() => handleItem(idx)}
                >
                  {item}
                </ItemSelect>
              </>
            )}
            <TempSelect />
          </React.Fragment>
        ))}
        <OutsideSelect />
      </SelectWrapper>
    </Container>
  )
}

export default HeaderTab

const Container = styled.div`
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '768px')};
  align-self: center;

  /* max-width: 768px; */

  min-width: 320px;
  display: ${(props) => (props.isDesktop ? 'flex' : 'none')};
  flex-direction: row;
  margin-bottom: 30px;

  @media ${(props) => props.theme.tablet} {
    margin-top: 30px;
    display: flex;
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 10px;
    margin-bottom: 20px;
  }
`

const OutsideSelect = styled.div`
  flex: 1;
  /* width: 120px; */
  border-bottom: 4px solid ${colors.G3};
  justify-content: space-between;
`

const ItemSelect = styled.div`
  display: flex;
  justify-content: center;
  /* width: 120px; */
  height: 43px;
  border-bottom: ${(props) =>
    props.isActive ? `4px solid ${colors.mainG}` : `4px solid ${colors.G3}`};
  font-size: 16px;
  color: ${colors.BK};
  font-weight: 700;
  cursor: pointer;

  @media ${(props) => props.theme.tablet} {
    color: ${(props) => (props.isActive ? `${colors.BK}` : `${colors.G4}`)};
  }

  @media ${(props) => props.theme.mobile} {
    color: ${colors.BK};
    font-size: 14px;
    width: 100%;
    height: 39px;
    min-width: 120px;
  }
`
const ItemSelectGap = styled.div`
  width: 100px;
`

const TempSelect = styled.div`
  width: 20px;
  height: 43px;
  border-bottom: 4px solid ${colors.G3};
  display: none;

  @media ${(props) => props.theme.tablet} {
    display: flex;
  }

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* height: 50px;
  max-width: 321px;
  cursor: pointer; */
`

const DivideLine = styled.div`
  width: 1px;
  background-color: ${colors.mainG};
`
